// React
import { memo, useMemo } from 'react'

// Interfaces
import { IPreviewImagesProps } from './interfaces'

// Components
import { PreviewActionButtons, Progress } from 'components/base/BaseUploader/BaseUploader/components'

// Uploady
import { BatchItem } from '@rpldy/chunked-uploady'

const PreviewImages = memo(({ id, name, url, files, onRetry, onAbort, onChange }: IPreviewImagesProps) => {
  /**
   * @description Get file
   *
   * @return {BatchItem} BatchItem
   */
  const file = useMemo(() => {
    return files.find(file => file.id === id) as BatchItem
  }, [files, id])

  return file ? (
    <div className="flex flex-col" id={`content-uploady-${file.id}`}>
      <img src={url} alt={name} onClick={event => event.stopPropagation()} />

      {/* Progress */}
      <Progress file={file} />

      {/* Action Buttons */}
      <div className="flex items-center justify-center text-center">
        <PreviewActionButtons withLabel={false} file={file} onRetry={onRetry} onAbort={onAbort} onChange={onChange} />
      </div>
    </div>
  ) : (
    <></>
  )
})

export { PreviewImages }
